import React, { Component } from 'react';
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import * as actions from "../../actions/ordersAction";
import * as symbols from "../../operations/symbols";
import CommonHeaderComponent from "../headers/CommonHeaderComponent";
import MultiImageUploaderComponent from '../core/MultiImageUploaderComponent';
import { USER_TYPE } from './../../operations/constants';


class StoreImageComponent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      uploadedImages: [],
      selectedImages: [],
      imageCompressionFailed: false,
    }
  }

  goToVerifyProducts = () => {
    this.props.history.push({
      pathname: `/order/${this.props.match.params.id}/products`,
      state: {
        id: this.props.match.params.id,
        orderNumber: this.props.location.state.orderNumber,
      }
    })
  }

  componentDidMount() {
    this.props.actions.getOrderDetails(this.props.match.params.id);
  }

  componentDidUpdate(prevProps) {
    const { uploadImagesStatus, getOrdersStatus, imageCompressionStatus } = this.props;
    if (uploadImagesStatus !== prevProps.uploadImagesStatus && uploadImagesStatus === symbols.STATUS_DONE) {
      this.goToVerifyProducts();
    }

    if(prevProps.imageCompressionStatus.status !== imageCompressionStatus.status && imageCompressionStatus.status === symbols.STATUS_FAIL) {
      this.setState({imageCompressionFailed: true});
    }

    if (getOrdersStatus !== prevProps.getOrdersStatus && getOrdersStatus === symbols.STATUS_DONE) {
      let storeImages = this.props.orders.orderDetails.images.reduce((acc, ele) => {
        if (ele.entityType === 'store_image' && ele.userType === USER_TYPE.DA) {
          acc.push(ele)
        }
        return acc
      }, [])
      this.setState({ uploadedImages: storeImages })
    }

  }

  onSubmit = (payload) => {
    const orderId = this.props.orders.orderDetails.orderDetail.orderId;
    payload.set('imageType', 'store_image');
    payload.set('orderId', orderId);
    this.props.actions.uploadImages(payload, "storeImages");
  }

  render() {

    if (!this.props.location.state) {
      return (
        <React.Fragment>
          <CommonHeaderComponent title={`Store images`} enableBack={true}/>
          <div className="pd-top-global fs-18 red-text center">
            Unauthorized!!!
          </div>
        </React.Fragment>
      )
    }

      return(
        <div className="pd-top-global gray-wrap mh-100">
          <CommonHeaderComponent title={`Store images`} enableBack={true}/>
              <MultiImageUploaderComponent
                imageType="store_image"
                uploadButtonText="Upload Store Images"
                orderId={this.props.location.state.id}
                onSubmit={this.onSubmit}
                uploadedImages={this.state.uploadedImages}
                onSkipUpload={this.goToVerifyProducts}
                selectedImages={this.props.orders.storeImages[this.props.location.state.id] ? this.props.orders.storeImages[this.props.location.state.id] : [] }
                imageCompressionFailed={this.state.imageCompressionFailed}
              />
        </div>
      )
  }
}


export default withRouter(connect(
  state => ({
    getOrdersStatus: state.statuses.getOrderDetails.status,
    getOrdersError: state.statuses.getOrderDetails.error,
    uploadImagesStatus: state.statuses.uploadImages.status,
    uploadImagesError: state.statuses.uploadImages.errors,
    imageCompressionStatus: state.statuses.imageCompression,
    orders: state.orders,
    images: state.orders.images,
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch)
  }),
)(StoreImageComponent));
